// extracted by mini-css-extract-plugin
module.exports = {"attention":"tableRow_attention__1yDWV","subTitle":"tableRow_subTitle__lu-Qs"};